import { createClient } from "@propelauth/javascript";
import { getEnv } from "./config/env";

const authUrl = getEnv("VITE_AUTH_URL", "https://auth.silvestre.club");

export const authClient = createClient({
  authUrl,
  enableBackgroundTokenRefresh: true,
});
